import React from "react";
import { constructCurrency } from "common/currency";
import { useFiatCurrency } from "@/hooks/firestore/user/useFiatCurrency";
import type { Maybe } from "@/types/utilities";

type PayoutProps = {
  amount: Maybe<number | string>;
};

/**
 * Display TBD, $x, or format currency from cents if a number is provided
 * Note: Payout should not show SP
 */
const Payout = ({ amount }: PayoutProps) => {
  const currency = useFiatCurrency();

  return (
    <div>
      {typeof amount === "number"
        ? constructCurrency(amount || 0, {
            currencyType: currency,
            roundDown: true,
          })
        : amount}
    </div>
  );
};

export { Payout };
